import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWorkspaceUserDelete } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_delete';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_user_delete = createAsyncThunkSafe<void, RequestWorkspaceUserDelete>(
  ENUM__network_event_client_to_server.WORKSPACE_USER_DELETE,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_USER_DELETE, request);
  },
);

export function init_remote_workspace_user_delete(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_user_delete.pending, (state, action) => {})
    .addCase(remote_workspace_user_delete.rejected, (state, action) => {})
    .addCase(remote_workspace_user_delete.fulfilled, (state, action: PayloadAction) => {});
}
